import { CreateExtractCssFromPropsParams } from 'style-utils/core/core.types';

export const mapScales = (...args: CreateExtractCssFromPropsParams[]) => {
  const scales: Record<string, string> = {};
  args.forEach((arg: CreateExtractCssFromPropsParams) => {
    Object.keys(arg).forEach((key: string) => {
      const property = arg[key];
      if (typeof property === 'object' && property?.themeKey)
        scales[property.property || key] = property.themeKey;
    });
  });

  return scales;
};
